jQuery(document).ready(function($){
  $('.tab-book-studio .item').click(function(){
    $('.tab-book-studio .item').not(this).find('.content').hide().removeClass('test');
    $('.tab-book-studio .item').not(this).find('.title').removeClass('active');
    $(this).find('.content').toggle().toggleClass('test');
    $(this).find('.title').toggleClass('active');
    $(this).addClass('left');
    if ($('.tab-book-studio .item').find('.content').hasClass("test")) {
      $(this).parent().find('title').addClass('active');
      $('.tab-book-studio .item').addClass('left');
    }else{
      $(this).parent().find('title').removeClass('active');
      $('.tab-book-studio .item').removeClass('left');
    }
    // $(window).scrollTop(0);
  });
  
  $('.loyalty-program .already a.login').on('click',function(){
    $('.loyalty-program .already .form-login').toggle('show');
  });
  $(".redeem-points .redeem-points-content .sign-up a").click(function () {
    var data_id = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $(data_id).offset().top - 80
    }, '5000');
  });
});